import type { MenuAt } from '@feral/ui'
import { create } from 'zustand'

/**
 * Taking a favorite off always asks first (Remove {name} from favorites?), wherever it's done: a star
 * on a tile, a card, a profile, a spot or a Favorites row, or a "..." menu's row. One sheet for all of
 * them, drawn by the Shell (RemoveFavorite.tsx) rather than inside a tile, whose taps and long press
 * would catch its own; asked from inside a popup or a pinned panel, it opens in that panel, as a menu's
 * own confirm does. Adding one never asks.
 */
export interface RemoveAsk {
  name: string
  kind: 'person' | 'spot'
  /** takes it off; a throw keeps the sheet open with what went wrong */
  remove: () => Promise<unknown>
  /** from a menu opened at the pointer: the sheet opens there too */
  at?: MenuAt | null
  /** what was tapped: inside a popup's panel, the sheet opens in that panel */
  from?: Element | null
}

export const useRemoveAsk = create<{ ask: RemoveAsk | null; panel: Element | null }>(() => ({
  ask: null,
  panel: null,
}))

export function askRemoveFavorite(ask: RemoveAsk) {
  // Found now: a menu's row is gone once the menu closes.
  useRemoveAsk.setState({ ask, panel: ask.from?.closest('.fm-popup__panel') ?? null })
}
